import React from 'react'
import { Link } from '@material-ui/core'
import LaunchIcon from '@material-ui/icons/Launch'
import { useExternalSiteLinkBarStyles } from './external-site-link-bar.styles'

export type ExternalSiteLinkBarProps = {
  href: string
  children: React.ReactNode
  /** Donate stepper: divider + spacing above the bar */
  dividerAbove?: boolean
  className?: string
}

/** Full-width external link bar (tinted surface + primary border + launch icon). */
export const ExternalSiteLinkBar: React.FC<ExternalSiteLinkBarProps> = ({
  href,
  children,
  dividerAbove = false,
  className,
}) => {
  const classes = useExternalSiteLinkBarStyles()

  if (!href?.trim()) {
    return null
  }

  return (
    <div
      className={[
        classes.row,
        dividerAbove ? classes.rowDivider : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Link
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {children}
        <LaunchIcon className={classes.icon} aria-hidden />
      </Link>
    </div>
  )
}
